import React from 'react';
import PropTypes from 'prop-types';
import { Select, Form, DatePicker, TimePicker, InputNumber, Checkbox, Icon } from 'antd';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import './EventTimeSelectorComponent.scss';

const messages = defineMessages({
  allDay: {
    id: 'EventTimeSelector.AllDay',
    defaultMessage: 'All Day',
  },
  minutes: {
    id: 'EventTimeSelector.Minutes',
    defaultMessage: 'Minutes',
  },
  hours: {
    id: 'EventTimeSelector.Hours',
    defaultMessage: 'Hours',
  },
  days: {
    id: 'EventTimeSelector.Days',
    defaultMessage: 'Days',
  },
  weeks: {
    id: 'EventTimeSelector.Weeks',
    defaultMessage: 'Weeks',
  },
  span: {
    id: 'EventTimeSelector.Placeholder.Span',
    defaultMessage: 'span',
  },
});

function EventTimeSelector(props) {
  const { Option } = Select;
  const FormItem = Form.Item;
  const {
    time,
    disable: disableTime,
    intl,
    defaultDuration,
    decorators,
    type,
    handleEventTimeChange,
    configDate,
    getFieldDecorator,
    configTime,
    onClickMarked,
    eventsOverlapCount,
  } = props;
  let disable = false;
  if (time === 'old') {
    disable = true;
  }
  const durationElement = (
    <Select
      disabled={disable || disableTime}
      className="duration"
      onChange={value => handleEventTimeChange(value, decorators.slotTimeUnit)}
    >
      <Option value="Minutes">
        <FormattedMessage {...messages.minutes} />
      </Option>
      <Option value="Hours">
        <FormattedMessage {...messages.hours} />
      </Option>
      <Option value="Days">
        <FormattedMessage {...messages.days} />
      </Option>
      <Option value="Weeks">
        <FormattedMessage {...messages.weeks} />
      </Option>
    </Select>
  );
  const checkboxElement = (
    <Checkbox
      onChange={e => {
        onClickMarked(e);
        handleEventTimeChange(e.target.checked);
      }}
      disabled={disable}
    >
      <FormattedMessage {...messages.allDay} />
    </Checkbox>
  );
  return (
    <div className="event-time-select">
      <div className="date-picker-div">
        <FormItem
          label={time === 'new' && type === 'update' ? 'Propose Time' : 'Time'}
          colon={false}
          style={{ marginBottom: 24, fontWeight: 500, fontFamily: 'Roboto' }}
        >
          {getFieldDecorator(decorators.datePicker, configDate)(
            <DatePicker
              disabled={disable}
              format="MM/DD/YYYY"
              className="event-date-picker"
              onChange={value => handleEventTimeChange(value, decorators.datePicker)}
              getCalendarContainer={triggerNode => triggerNode.parentNode}
            />
          )}
        </FormItem>
      </div>

      <div className="time-picker-form-item">
        <FormItem label=" " colon={false} style={{ marginBottom: 0, fontWeight: 500, fontFamily: 'Roboto' }}>
          {getFieldDecorator(decorators.timePicker, configTime)(
            <TimePicker
              use12Hours
              format="h:mma"
              disabled={disable || disableTime}
              onChange={value => handleEventTimeChange(value, props.decorators.timePicker)}
              className="event-time-picker"
            />
          )}
        </FormItem>
      </div>
      <div className="duration-div">
        <FormItem label="Duration" colon={false} style={{ marginBottom: 0, fontWeight: 500, fontFamily: 'Roboto' }}>
          {getFieldDecorator(decorators.timeSpan, {
            initialValue: defaultDuration || 30,
            rules: [{ required: true, message: 'Please input duration' }],
          })(
            <InputNumber
              disabled={disable || disableTime}
              placeholder={intl.formatMessage({ ...messages.span })}
              onChange={value => handleEventTimeChange(value, decorators.timeSpan)}
              className="duration-input"
            />
          )}
        </FormItem>
      </div>

      <div className="slot-unit-create-meeting">
        <FormItem label=" " colon={false} style={{ marginBottom: 0 }}>
          {getFieldDecorator(decorators.slotTimeUnit, {
            initialValue: 'Minutes',
          })(durationElement)}
        </FormItem>
      </div>

      <div className="checkbox-div">
        <FormItem label=" " colon={false} style={{ marginBottom: 0 }}>
          {getFieldDecorator(decorators.allDay, {
            valuePropName: 'checked',
          })(checkboxElement)}
        </FormItem>
      </div>
      {eventsOverlapCount ? (
        <div className="events-overlap-info">
          <Icon type="info-circle" theme="filled" />
          {eventsOverlapCount} event(s) found at this time.
        </div>
      ) : null}
    </div>
  );
}

EventTimeSelector.propTypes = {
  eventsOverlapCount: PropTypes.number,
  decorators: PropTypes.shape({
    allDay: PropTypes.string,
    slotTimeUnit: PropTypes.string,
    timeSpan: PropTypes.string,
    timePicker: PropTypes.string,
    datePicker: PropTypes.string,
  }).isRequired,
  getFieldDecorator: PropTypes.func.isRequired,
  defaultDuration: PropTypes.number.isRequired,
  handleEventTimeChange: PropTypes.func,
  type: PropTypes.string,
  time: PropTypes.string.isRequired,
  disable: PropTypes.bool.isRequired,
  configTime: PropTypes.shape({}).isRequired,
  configDate: PropTypes.shape({}).isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onClickMarked: PropTypes.func.isRequired,
};

EventTimeSelector.defaultProps = {
  eventsOverlapCount: 0,
  type: '',
  handleEventTimeChange: () => {},
};

export default injectIntl(EventTimeSelector);
